import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IUser } from '../interfaces';
import { IProfile, IProfileForm } from '@app/private-office/modules/profile/interfaces';

const userActionGroup = createActionGroup({
  source: 'User',
  events: {
    'Get User': emptyProps(),
    'Get User Success': props<{ user: IUser }>(),
    'Get User Failure': emptyProps(),
  },
});
const profileActionGroup = createActionGroup({
  source: 'Profile',
  events: {
    'Get Profile': emptyProps(),
    'Get Profile Success': props<{ profile: IProfile }>(),
    'Get Profile Failure': emptyProps(),
    'Update Profile': props<{ profile: IProfileForm }>(),
    'Update Profile Success': props<{ profile: IProfile }>(),
    'Update Profile Failure': emptyProps(),
  },
});

export const { getUser, getUserSuccess, getUserFailure } = userActionGroup;

export const {
  getProfile,
  getProfileSuccess,
  getProfileFailure,
  updateProfile,
  updateProfileSuccess,
  updateProfileFailure,
} = profileActionGroup;
